import {
  LoggedIn,
  Logout,
  WelcomeNavigation,
  Deactivate,
  Activate,
  ResumeFsm
} from '@/store/modules/fsm/messages';
import router from '@/router/index';
import { post } from '@/store/modules/fsm/index';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let { addState, addRegion, PseudoStateKind } = api;
    let here = addRegion('welcome',parent);
    addState('init',here,PseudoStateKind.Initial);
    addState('dormant',here);
    addState('ready',here);
    addState('activating',here);
    addState('active',here);
  }
  else
  {
    let { messageIs, nextRouterHook, navigate } = api;
    let here = parent.welcome;
    here.init
      .to(here.dormant);
    here.dormant
      .to(here.ready)
      .when(messageIs(LoggedIn));
    here.ready
      .to(here.dormant)
      .when(messageIs(Logout));
    here.ready
      .to(here.activating)
      .when(messageIs(WelcomeNavigation))
      .effect(({}={},{next}) => post({ message:Deactivate, next }));
    here.activating
      .to()
      .when(messageIs(Deactivate))
      .effect(({}={},{next})=>post({message:Activate,next}));
    here.activating
      .to(here.active)
      .when(messageIs(Activate))
      .effect(nextRouterHook);
    here.active
      .to(here.ready)
      .when(messageIs(Deactivate));
    here.active
      .to()
      .when(messageIs(WelcomeNavigation))
      .effect(nextRouterHook);
    here.active
      .to()
      .when(messageIs(ResumeFsm))
      .effect(({}={}, {next})=>post({message:Activate,next})
      );
  }
};
